import React from 'react'
import Dialog from '@mui/material/Dialog'
import DialogTitle from '@mui/material/DialogTitle'
import DialogContent from '@mui/material/DialogContent'
import DialogActions from '@mui/material/DialogActions'
import Button from '@mui/material/Button'
import Typography from '@mui/material/Typography'

/**
 * Confirms removing one slot from a team season's slots map. Hard delete, unlike most things
 * here: a slot is pure availability config with nothing hanging off it, and the map has no
 * room for tombstones.
 *
 * Reservations already made inside the slot are untouched. That is the point of the warning -
 * closing the window teams book through does not, and must not, unbook anyone.
 */
function TeamSeasonSlotDeleteDialog({ open, slot, onCancel, onConfirm, working }) {
  const label = slot ? (slot.displayName || (slot.starttime || '') + ' - ' + (slot.endtime || '')) : ''
  return (
    <Dialog open={open} onClose={onCancel} maxWidth='sm' fullWidth>
      <DialogTitle>Poistetaanko vuoro?</DialogTitle>
      <DialogContent>
        <Typography variant='body1' gutterBottom>
          <b>{label}</b>
        </Typography>
        <Typography variant='body2' color='text.secondary' sx={{ mt: 1 }}>
          Vuoro poistuu kaudesta, eivätkä joukkueet voi enää varata sen ajalta.
        </Typography>
        <Typography variant='body2' color='text.secondary' sx={{ mt: 1 }}>
          Jo tehdyt varaukset jäävät voimaan. Jos ne pitää perua, tee se kalenterissa erikseen.
        </Typography>
      </DialogContent>
      <DialogActions>
        <Button onClick={onCancel} disabled={working}>
          Peruuta
        </Button>
        <Button onClick={onConfirm} variant='contained' color='error' disabled={working}>
          {working ? 'Poistetaan...' : 'Poista'}
        </Button>
      </DialogActions>
    </Dialog>
  )
}

export default TeamSeasonSlotDeleteDialog
